import { render } from "./Modals.vue?vue&type=template&id=7824ea82"
import script from "./Modals.vue?vue&type=script&lang=js"
export * from "./Modals.vue?vue&type=script&lang=js"

import "./Modals.vue?vue&type=style&index=0&id=7824ea82&lang=scss"

import exportComponent from "/home/prof1/projects/intercom_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__